import { NewSettingsService } from './new-settings-service';

export default NewSettingsService;
